export const italianTranslations = {
  // Meta & General
  pageTitle: "Video marketing con IA per aziende | Future Level Svizzera",
  pageDescription: "Produzione video automatizzata con intelligenza artificiale – Future Level ti aiuta a risparmiare tempo e denaro.",
  
  // Navigation
  home: "Home",
  services: "Servizi",
  whyFutureLevel: "Perché Future Level?",
  blog: "Blog",
  contact: "Contatto",
  breadcrumbNavigation: "Navigazione breadcrumb",
  
  // Pricing Page
  pricing: "Prezzi",
  pricingSubtitle: "Prezzi trasparenti per la produzione video IA con il miglior rapporto qualità-prezzo",
  pricingDescription: "Scopri i nostri modelli di prezzo trasparenti per la produzione video basata sull'IA: Dai singoli video agli abbonamenti mensili.",
  
  // Service Names
  productVideos: "Video di Prodotti",
  kiVideoProductShowcase: "Video di Prodotti IA",
  explainerVideos: "Video Esplicativi",
  socialMediaAds: "Pubblicità per Social Media",
  reels: "Reels",
  
  // Service Descriptions
  productVideosDesc: "Mostra i tuoi prodotti nella luce migliore – automaticamente, velocemente, in modo convincente.",
  explainerVideosDesc: "Contenuti complessi spiegati in modo semplice e comprensibile dall'IA.",
  socialMediaAdsDesc: "Video brevi ad alte prestazioni per le tue campagne su Instagram, Facebook, TikTok e altro.",
  reelsDesc: "Portata massima grazie ai reels di tendenza con IA nel tuo branding.",
  
  // Hero Section
  heroTitle: "Video Marketing Orientato al Futuro con l'IA",
  heroSubtitle: "Risparmia tempo e costi, massimizza l'impatto",
  contactUs: "Contattaci",
  learnMore: "Scopri di Più",
  
  // Why Future Level
  whyFutureLevelSubtitle: "La nostra tecnologia IA crea video più velocemente di qualsiasi agenzia – senza attori, telecamere o produzione in studio.",
  costSaving: "Risparmio sui Costi",
  timeSaving: "Risparmio di Tempo",
  increaseSales: "Aumento delle Vendite",
  targetAudience: "Su Misura per il Tuo Pubblico Target",
  costSavingDesc: "Riduci i tuoi costi di produzione fino al 70% rispetto alle produzioni video convenzionali.",
  timeSavingDesc: "Ricevi i tuoi video finiti in pochi giorni anziché settimane o mesi.",
  increaseSalesDesc: "Aumenta il tuo tasso di conversione e le vendite con contenuti visivi convincenti.",
  targetAudienceDesc: "Ogni video è precisamente adattato al tuo pubblico target e al tuo settore.",
  
  // Why AI Videos Section
  whyKIVideosTitle: "Video AI per social media: 300% di engagement in più e 70% di risparmio sui costi",
  whyKIVideosPoint1: "Team di esperti che utilizzano strumenti AI avanzati per video Instagram, TikTok e Facebook - sempre all'avanguardia della tecnologia",
  whyKIVideosPoint2: "Team composto esclusivamente da editor video professionisti con anni di esperienza nella produzione video digitale",
  whyKIVideosPoint3: "Concentrazione totale sul tuo successo attraverso strategie video personalizzate basate sull'IA",
  whyKIVideosPoint4: "Team professionale con competenza in tutti i formati social media (Instagram Reels, Facebook Ads, TikTok)",
  
  // Services Section
  ourServices: "I Nostri Servizi",
  servicesSubtitle: "Video di marketing professionali basati sull'IA che trasmettono efficacemente il tuo messaggio.",
  
  // Testimonials
  clientTestimonials: "Testimonianze dei Clienti",
  testimonialsSubtitle: "Cosa dicono i nostri clienti di noi",
  testimonial1: "I video IA di Future Level hanno aumentato il tasso di conversione nel nostro negozio online del 35%. Un rapporto qualità-prezzo incredibile!",
  testimonial2: "Usiamo i video esplicativi per argomenti di consulenza complessi. I nostri clienti sono entusiasti di come i contenuti sono preparati in modo comprensibile.",
  testimonial3: "Gli annunci sui social media hanno aiutato la nostra clinica a ottenere una notorietà locale significativamente più alta. Il ROI è impressionante.",
  
  // Blog Section
  latestBlogPosts: "Ultimi Post del Blog",
  blogSubtitle: "Tendenze e consigli sul video marketing e l'IA nel marketing",
  blogTitle1: "Tendenze del Video Marketing 2025",
  blogExcerpt1: "Quali formati video e tecnologie dominano il marketing quest'anno? Approfondimenti e previsioni.",
  blogTitle2: "IA nel Marketing - Rivoluzione o Hype?",
  blogExcerpt2: "Come l'intelligenza artificiale sta cambiando in modo sostenibile il marketing e quali opportunità si presentano per le aziende.",
  blogTitle3: "Case Study: Campagne Video di Successo",
  blogExcerpt3: "Analisi di tre campagne video particolarmente riuscite e cosa puoi imparare da esse.",
  readMore: "Leggi di Più",
  viewAllPosts: "Vedi Tutti i Post",
  
  // Blog Page
  blogPageTitle: "Conoscenza di Esperti: Video Marketing & IA",
  blogPageSubtitle: "Tendenze attuali, suggerimenti pratici e storie di successo dal mondo del video marketing basato sull'IA",
  blogMetaDescription: "Il blog Future Level offre conoscenze di esperti sul video marketing IA, tendenze e best practices per le aziende in Svizzera.",
  backToBlog: "Torna al Blog",
  blogContentPlaceholder: "Questa sezione contiene informazioni dettagliate sull'argomento. Su un sito web attivo, il contenuto completo dell'articolo sarebbe qui.",
  blogSubheading1: "Principali Approfondimenti",
  blogSubheading2: "Applicazioni Pratiche",
  blogSubheading3: "Conclusione e Prospettive",
  blogCTA: "Vorresti saperne di più sulle nostre soluzioni video IA?",
  
  // Contact Form
  contactSubtitle: "Pronto a rivoluzionare la tua strategia di video marketing con l'IA? Compila il nostro modulo di contatto – ti risponderemo entro 24 ore.",
  fullName: "Nome Completo",
  email: "Email",
  company: "Azienda",
  phone: "Numero di Telefono",
  projectDescription: "Descrizione del Progetto",
  send: "Invia",
  formSubmitSuccess: "Messaggio Inviato!",
  formSubmitMessage: "Grazie per la tua richiesta. Ti contatteremo entro 24 ore.",
  
  // Clients Section
  trustedBy: "Queste Aziende Si Fidano di Noi",
  
  // Legal Page
  tableOfContents: "Indice",
  legalTitle: "Note Legali",
  legalDescription: "Dettagli dell'azienda e informazioni legali sulla nostra agenzia di video marketing AI a Emmen, Svizzera",
  contactInfo: "Informazioni di contatto",
  companyDetails: "Dettagli dell'azienda",
  vatInfo: "Informazioni IVA",
  authorizedRepresentative: "Rappresentante autorizzato",
  legalNotices: "Avvisi legali",
  disclaimer: "Disclaimer",
  copyright: "Diritti d'autore",
  lastUpdated: "Ultimo aggiornamento: Maggio 2025",
  backToTop: "Torna all'inizio",
  collapseTOC: "Comprimi indice",
  expandTOC: "Espandi indice",
  navigateToSection: "Naviga alla sezione",
  
  // Footer
  footerDescription: "Future Level - Il tuo partner per video di marketing basati sull'IA in Svizzera. Aumenta il tuo successo con soluzioni video innovative.",
  quickLinks: "Link Rapidi",
  allRightsReserved: "Tutti i diritti riservati.",
  impressum: "Impronta",
  privacy: "Informativa sulla Privacy",
  terms: "Termini e Condizioni"
};
